import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Container from "react-bootstrap/esm/Container";
import LandingPage from "./screens/LandingPage/LandingPage";
import Dashboard from "./screens/LandingPage/Dashboard";
import LoginScreen from "./screens/LoginScreen/LoginScreen";

import ChangePassword from "./screens/LoginScreen/ChangePassword";
import RegisterScreen from "./screens/RegisterScreen/RegisterScreen";

import ManageUSers from "./screens/User/ManageUsers";
import AssignRoles from "./screens/User/AssignRoles";
import SendForApproval from "./screens/Frght/SendForApproval";
import SalaryJvUpload from "./screens/SalaryJv/SalaryJvUpload";
import LinkFrghtOrder from "./screens/Frght/LinkFrghtOrder";
import Gstr2bUploadAndEdit from "./screens/Gstr2B/Gstr2bUploadAndEdit";
import PostGST2bData from "./screens/Gstr2B/PostGST2bData";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Container>
          <Header />
          <main>
            <Routes>
              <Route path="/" Component={LandingPage} exact />
              <Route path="/Dashboard" Component={Dashboard} exact />
              <Route path="/login" Component={LoginScreen} exact />
              <Route path="/change-password" Component={ChangePassword} exact />
              <Route path="/register" Component={RegisterScreen} exact />
              <Route path="/manageUsers" Component={ManageUSers} exact />
              <Route path="/AssignRoles" Component={AssignRoles} exact />
              <Route path="/SendForApproval" Component={SendForApproval} exact />
              <Route path="/SalaryJvUpload" Component={SalaryJvUpload} exact />
              <Route path="/LinkFrghtOrder" Component={LinkFrghtOrder} exact />
              <Route path="/Gstr2bUploadAndEdit" Component={Gstr2bUploadAndEdit} exact />
              <Route path="/PostGST2bData" Component={PostGST2bData} exact />
            </Routes>
          </main>
          <Footer />
        </Container>
      </BrowserRouter>
    </div>
  );
}

export default App;
